import { useEffect } from 'react';
import './App.css';
import MyRoutes from './routers';
import { useItems } from './contains/ItemContext';
import { getItems } from './contains/fetch';
import { getItemsCategory } from './contains/fetchCategoryMongo';
import { getMediumArticles } from './contains/fetchMediumArticles';
import { getEngine } from "./utils/webllmengine"; 
import { WebLLMProvider } from "./app/singles/WebLLMContext"; // ✅ add this



function App() {
  const { setCategories,setArticles } = useItems();


  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const items = await getItemsCategory();
        setCategories(items);
        console.log(items);
      } catch (error) {
        console.error('Error fetching items:', error);
      }
    };
    const fetchMediumArticles = async () => {
      try {
        const items = await getMediumArticles();
            const sortedItems = [...items].sort((a, b) => {
      const dateA = new Date(a.updated || a.pubDate || a.date).getTime();
      const dateB = new Date(b.updated || b.pubDate || b.date).getTime();
      return dateB - dateA; // latest first
    });
        console.log(sortedItems);

        setArticles(sortedItems);
      } catch (error) {
        console.error('Error fetching items:', error);
      }
    };
    fetchMediumArticles();
    // fetchItems();
    fetchCategories();
    // --- ✅ preload WebLLM engine once ---
    if ("requestIdleCallback" in window) {
      requestIdleCallback(() => {
        console.log("[App] Preloading WebLLM engine...");
        getEngine();
      });
    } else {
      setTimeout(() => {
        console.log("[App] Preloading WebLLM engine (fallback)...");
        getEngine();
      }, 500);
  }
}, []);
  return (
        <WebLLMProvider>
      <MyRoutes />
      </WebLLMProvider>
  );
}

export default App;
